//Custo css import
import './style.css'

//Widgets import
import NewProduct from '../../organisms/newProduct/view';
import ProductsTable from '../../organisms/productsTable/view';
import LoadProductsFromFile from '../../organisms/loadProductsFromFile/view';
import NewNote from '../../organisms/newNote/view';

import TabSwitcher from '../../molecules/TabSwitcher/view';
import { useContext, useEffect, useState, useMemo } from 'react';
import { useNavigationIntent } from '../../../hooks/useNavigationIntent';

import ListNotes from '../../organisms/listNotes/view';
import { roleContext } from '../../../context/role/context';
import Taxes from '../../organisms/taxes/view';
import ButtonGroup from '../../molecules/buttonGroup/view';
import CustomBox from '../../atoms/container/container';
import { useOnboardingTour } from '../../../hooks/useOnboardingTour';

function ProductsHub() {
    useOnboardingTour();

    const { profile } = useContext(roleContext);
    const [tabIndex, setTabIndex] = useState(0);
    const intent = useNavigationIntent();
    const [initialFilter, setInitialFilter] = useState({});

    useEffect(() => {
        if (intent) {
            if (intent.tabIndex !== undefined) setTabIndex(intent.tabIndex);
            if (intent.params) setInitialFilter(intent.params);
        }
    }, [intent]);

    const tabs = useMemo(() => [
        {
            name: "Productos",
            component: () => (
                <CustomBox>
                    <ProductsTable
                        profile={profile}
                        type='stock'
                        initialFilter={initialFilter}
                    />
                </CustomBox>
            )
        },
        {
            name: "Notas de Inventario",
            component: () => (
                <CustomBox style={{ maxHeight: "80%" }}>
                    <ListNotes
                        profile={profile}
                    />
                </CustomBox>
            )
        }
    ], [profile, initialFilter]);

    return (
        <>
            <ButtonGroup
                title="Inventario de Productos"
                description="Control absoluto de tus existencias y notas de inventario."
            >
                <Taxes />
                {
                    tabIndex === 0 && (
                        <>
                            <NewProduct
                                id="products-page"
                                profile={profile}
                            />
                            <LoadProductsFromFile />
                        </>
                    )
                }
                {
                    tabIndex === 1 && <NewNote profile={profile} />
                }
            </ButtonGroup>
            <br></br>
            <TabSwitcher tabs={tabs} onTabChange={setTabIndex} activeTabIndex={tabIndex} hashKey="tab" />
        </>
    )
}

export default ProductsHub

